export const TASK_TYPES = {
  REVIEW_CATEGORY: 'reviewCategory',
} as const;

export const TASK_TYPE_OPTIONS = [
  {
    value: TASK_TYPES.REVIEW_CATEGORY,
    label: 'Confirm Category',
  },
];

export type TaskType = (typeof TASK_TYPES)[keyof typeof TASK_TYPES];
